import { Button, Card, CircularProgress } from '@mui/material'
import { useEffect } from 'react'
import { FaRegFileLines } from 'react-icons/fa6'
import { useHistory } from 'react-router-dom'
import ExpiredDocumentsList from '../components/documentosVencidos/ExpiredDocumentsList'
import IconBack from '../components/IconBack'
import NotData from '../components/NotData'
import { useAuth } from '../context/AuthContext'
import { useGetData } from '../context/getDataContext'

const DocumentosVencidos = () => {
  const history = useHistory()
  const { validateAccess } = useAuth()
  const {
    expiredDocuments,
    expiredDocumentsLoading,
    expiredDocumentsError,
    getExpiredDocuments,
  } = useGetData()

  useEffect(() => {
    validateAccess()
    document.title = 'SisarmaApp | Vencimentos de Documentos'
  }, [validateAccess])

  const handleAccessDocument = (document) => {
    if (document.type === 'cr') {
      history.push('/perfil')
      return
    }

    const pessoaArmaID = Number(document.pessoaArmaID)

    if (!Number.isInteger(pessoaArmaID) || pessoaArmaID <= 0) return

    history.push(`/acervo-pessoal?pessoaArmaID=${pessoaArmaID}`)
  }

  return (
    <section>
      <Card className="relative">
        <div
          className="absolute top-6 right-5 text-xl cursor-pointer"
          onClick={() => history.push('/')}
        >
          <IconBack />
        </div>

        <div className="p-5">
          <div className="flex items-center gap-1">
            <FaRegFileLines />
            <h1 className="text-lg font-semibold">
              Vencimentos de documentos
            </h1>
          </div>
        </div>
      </Card>

      {expiredDocumentsLoading ? (
        <div className="flex justify-center py-10">
          <CircularProgress color="inherit" size={30} />
        </div>
      ) : expiredDocumentsError ? (
        <Card className="mt-2">
          <div className="p-5 flex flex-col md:flex-row md:items-center justify-between gap-3">
            <p>{expiredDocumentsError}</p>
            <Button
              color="error"
              variant="contained"
              onClick={getExpiredDocuments}
            >
              Tentar novamente
            </Button>
          </div>
        </Card>
      ) : expiredDocuments.length === 0 ? (
        <div className="mt-2">
          <NotData />
        </div>
      ) : (
        <ExpiredDocumentsList
          documents={expiredDocuments}
          onAccessDocument={handleAccessDocument}
        />
      )}
    </section>
  )
}

export default DocumentosVencidos
